// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Importar Bootstrap CSS desde CDN */

/* Variables de color */
:root {
  --primary-color: #385c29;
  --secondary-color: white;
  --text-color: black;
  --light-bg: #f8f9fa;
  --footer-text-color: var(--primary-color);
  --footer-bg-color: var(--secondary-color);
}

/* Estilos generales */
body {
  font-family: "Arial", sans-serif;
}

/* Navbar */
.navbar.bg-primary-custom {
  background-color: var(--primary-color) !important;
}

.bg-green-1 {
  background-color: var(--primary-color) !important;
}

/* Suaviza el scroll cuando cambias el hash manualmente */
html { scroll-behavior: smooth; }

/* Asegura que cada sección tenga altura suficiente para centrar bien */
section{
  min-height: 90vh; /* o 100vh si tu contenido lo permite */
  scroll-margin: 0; /* evitamos interferir con el centrado por JS */
}


/* Ejemplo de colores/tamaños si no existen */
.bg-primary-custom { background-color: #2f5d35; }
.text-primary-custom { color: #2f5d35; }
.bg-white-custom { background: #fff; }

.navbar-logo {
  height: 36px;      /* ajusta a tu gusto */
  width: auto;
}



/* quita el estiramiento */
.ku-logo {
  width: auto !important;
  height: auto !important;
  max-width: 500px;      /* ajusta a tu gusto */
  display: block;
  margin: 0 auto;        /* centro horizontal */
}

/* Franja parcial, un poco más ancha y más arriba */
.hero-band {
  position: absolute;
  left: 0;           /* pegada a la izquierda */
  right: auto;       /* no la estires hasta la derecha */
  width: 70%;        /* AJUSTA este % a tu gusto (62–72% queda bien) */
  bottom: 12rem;      /* súbela (prueba 9–14vh) */
  z-index: 2;        /* por encima de la imagen */
}

/* Desktop grande: hazla un poco más corta para parecerse a la maqueta */
@media (min-width: 1200px) {
  .hero-band { width: 70%; bottom: 16vh; }
}

/* En móviles: que ocupe casi todo abajo */
@media (max-width: 991.98px) {
  .hero-band { width: 95%; left: 2.5%; bottom: 0; }
}



/*introduccion*/





/* -------- Footer base -------- */
.footer {
  position: relative;
  overflow: hidden;
}

.footer.border-top {
  border-top: 1px solid rgba(0,0,0,0.05);
}

.footer-desc {
  color: rgba(0,0,0,0.7);
  line-height: 1.6;
}

.footer-title {
  font-weight: 700;
  letter-spacing: .2px;
  margin-bottom: .75rem;
  color: var(--primary-custom, #2f5d35);
}

.footer-link {
  display: inline-block;
  padding: .15rem 0;
  color: var(--primary-custom, #2f5d35);
  text-decoration: none;
  border-bottom: 1px dashed transparent;
  transition: color .2s ease, border-color .2s ease, transform .15s ease;
}

.footer-link:hover,
.footer-link:focus {
  color: #1f3e24;
  border-bottom-color: rgba(47,93,53,.35);
  transform: translateY(-1px);
  text-decoration: none;
}

.footer-social {
  --size: 42px;
  width: var(--size);
  height: var(--size);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: rgba(47,93,53,0.08);
  color: var(--primary-custom, #2f5d35);
  text-decoration: none;
  transition: transform .15s ease, background .2s ease, box-shadow .2s ease;
}

.footer-social:hover,
.footer-social:focus {
  background: rgba(47,93,53,0.14);
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(0,0,0,0.08);
}

.footer-bottom {
  background: linear-gradient(180deg, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.05) 100%);
}

.footer-legal {
  color: rgba(0,0,0,0.65);
  text-decoration: none;
  transition: color .2s ease;
}

.footer-legal:hover,
.footer-legal:focus {
  color: rgba(0,0,0,0.9);
  text-decoration: underline;
}

.back-to-top {
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.06);
  color: var(--primary-custom, #2f5d35);
  backdrop-filter: blur(4px);
  text-decoration: none;
  transition: background .2s ease, transform .15s ease, box-shadow .2s ease;
}

.back-to-top:hover,
.back-to-top:focus {
  background: rgba(0,0,0,0.1);
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(0,0,0,0.08);
}

.bg-white-custom { background: #fff; }
.text-primary-custom { color: var(--primary-custom, #2f5d35); }

@media (max-width: 575.98px) {
  .footer-social { --size: 40px; }
  .back-to-top { right: .75rem; bottom: .75rem; }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAIrC,uBAAuB;AACvB;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA,yDAAyD;AACzD,OAAO,uBAAuB,EAAE;;AAEhC,uEAAuE;AACvE;EACE,gBAAgB,EAAE,uCAAuC;EACzD,gBAAgB,EAAE,+CAA+C;AACnE;;;AAGA,6CAA6C;AAC7C,qBAAqB,yBAAyB,EAAE;AAChD,uBAAuB,cAAc,EAAE;AACvC,mBAAmB,gBAAgB,EAAE;;AAErC;EACE,YAAY,OAAO,sBAAsB;EACzC,WAAW;AACb;;;;AAIA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB,OAAO,sBAAsB;EAC7C,cAAc;EACd,cAAc,SAAS,sBAAsB;AAC/C;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,OAAO,YAAY,0BAA0B;EAC7C,WAAW,QAAQ,mCAAmC;EACtD,UAAU,SAAS,iDAAiD;EACpE,aAAa,OAAO,2BAA2B;EAC/C,UAAU,SAAS,4BAA4B;AACjD;;AAEA,wEAAwE;AACxE;EACE,aAAa,UAAU,EAAE,YAAY,EAAE;AACzC;;AAEA,0CAA0C;AAC1C;EACE,aAAa,UAAU,EAAE,UAAU,EAAE,SAAS,EAAE;AAClD;;;;AAIA,eAAe;;;;;;AAMf,kCAAkC;AAClC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,qCAAqC;EACrC,qBAAqB;EACrB,qCAAqC;EACrC,sEAAsE;AACxE;;AAEA;;EAEE,cAAc;EACd,uCAAuC;EACvC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,qBAAqB;EACrB,yEAAyE;AAC3E;;AAEA;;EAEE,+BAA+B;EAC/B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;EACrC,0BAA0B;EAC1B,qBAAqB;EACrB,yEAAyE;AAC3E;;AAEA;;EAEE,2BAA2B;EAC3B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,mBAAmB,gBAAgB,EAAE;AACrC,uBAAuB,qCAAqC,EAAE;;AAE9D;EACE,iBAAiB,YAAY,EAAE;EAC/B,eAAe,aAAa,EAAE,cAAc,EAAE;AAChD","sourcesContent":["/* Importar Bootstrap CSS desde CDN */\n@import url(\"https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css\");\n@import url(\"https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css\");\n\n/* Variables de color */\n:root {\n  --primary-color: #385c29;\n  --secondary-color: white;\n  --text-color: black;\n  --light-bg: #f8f9fa;\n  --footer-text-color: var(--primary-color);\n  --footer-bg-color: var(--secondary-color);\n}\n\n/* Estilos generales */\nbody {\n  font-family: \"Arial\", sans-serif;\n}\n\n/* Navbar */\n.navbar.bg-primary-custom {\n  background-color: var(--primary-color) !important;\n}\n\n.bg-green-1 {\n  background-color: var(--primary-color) !important;\n}\n\n/* Suaviza el scroll cuando cambias el hash manualmente */\nhtml { scroll-behavior: smooth; }\n\n/* Asegura que cada sección tenga altura suficiente para centrar bien */\nsection{\n  min-height: 90vh; /* o 100vh si tu contenido lo permite */\n  scroll-margin: 0; /* evitamos interferir con el centrado por JS */\n}\n\n\n/* Ejemplo de colores/tamaños si no existen */\n.bg-primary-custom { background-color: #2f5d35; }\n.text-primary-custom { color: #2f5d35; }\n.bg-white-custom { background: #fff; }\n\n.navbar-logo {\n  height: 36px;      /* ajusta a tu gusto */\n  width: auto;\n}\n\n\n\n/* quita el estiramiento */\n.ku-logo {\n  width: auto !important;\n  height: auto !important;\n  max-width: 500px;      /* ajusta a tu gusto */\n  display: block;\n  margin: 0 auto;        /* centro horizontal */\n}\n\n/* Franja parcial, un poco más ancha y más arriba */\n.hero-band {\n  position: absolute;\n  left: 0;           /* pegada a la izquierda */\n  right: auto;       /* no la estires hasta la derecha */\n  width: 70%;        /* AJUSTA este % a tu gusto (62–72% queda bien) */\n  bottom: 12rem;      /* súbela (prueba 9–14vh) */\n  z-index: 2;        /* por encima de la imagen */\n}\n\n/* Desktop grande: hazla un poco más corta para parecerse a la maqueta */\n@media (min-width: 1200px) {\n  .hero-band { width: 70%; bottom: 16vh; }\n}\n\n/* En móviles: que ocupe casi todo abajo */\n@media (max-width: 991.98px) {\n  .hero-band { width: 95%; left: 2.5%; bottom: 0; }\n}\n\n\n\n/*introduccion*/\n\n\n\n\n\n/* -------- Footer base -------- */\n.footer {\n  position: relative;\n  overflow: hidden;\n}\n\n.footer.border-top {\n  border-top: 1px solid rgba(0,0,0,0.05);\n}\n\n.footer-desc {\n  color: rgba(0,0,0,0.7);\n  line-height: 1.6;\n}\n\n.footer-title {\n  font-weight: 700;\n  letter-spacing: .2px;\n  margin-bottom: .75rem;\n  color: var(--primary-custom, #2f5d35);\n}\n\n.footer-link {\n  display: inline-block;\n  padding: .15rem 0;\n  color: var(--primary-custom, #2f5d35);\n  text-decoration: none;\n  border-bottom: 1px dashed transparent;\n  transition: color .2s ease, border-color .2s ease, transform .15s ease;\n}\n\n.footer-link:hover,\n.footer-link:focus {\n  color: #1f3e24;\n  border-bottom-color: rgba(47,93,53,.35);\n  transform: translateY(-1px);\n  text-decoration: none;\n}\n\n.footer-social {\n  --size: 42px;\n  width: var(--size);\n  height: var(--size);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: rgba(47,93,53,0.08);\n  color: var(--primary-custom, #2f5d35);\n  text-decoration: none;\n  transition: transform .15s ease, background .2s ease, box-shadow .2s ease;\n}\n\n.footer-social:hover,\n.footer-social:focus {\n  background: rgba(47,93,53,0.14);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 14px rgba(0,0,0,0.08);\n}\n\n.footer-bottom {\n  background: linear-gradient(180deg, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.05) 100%);\n}\n\n.footer-legal {\n  color: rgba(0,0,0,0.65);\n  text-decoration: none;\n  transition: color .2s ease;\n}\n\n.footer-legal:hover,\n.footer-legal:focus {\n  color: rgba(0,0,0,0.9);\n  text-decoration: underline;\n}\n\n.back-to-top {\n  position: absolute;\n  right: 1rem;\n  bottom: 1rem;\n  width: 44px;\n  height: 44px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0,0,0,0.06);\n  color: var(--primary-custom, #2f5d35);\n  backdrop-filter: blur(4px);\n  text-decoration: none;\n  transition: background .2s ease, transform .15s ease, box-shadow .2s ease;\n}\n\n.back-to-top:hover,\n.back-to-top:focus {\n  background: rgba(0,0,0,0.1);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 18px rgba(0,0,0,0.08);\n}\n\n.bg-white-custom { background: #fff; }\n.text-primary-custom { color: var(--primary-custom, #2f5d35); }\n\n@media (max-width: 575.98px) {\n  .footer-social { --size: 40px; }\n  .back-to-top { right: .75rem; bottom: .75rem; }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
